export default __webpack_public_path__ + "static/media/cont13.7f08759f.jpeg";